/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () => import(/* webpackChunkName: '' */ `./components/${path}`).then(m => m.default || m)

export const routes = [
    {
        path: '/downloads',
        name: 'Downloads',
        component: page('DownloadList'),
    },
    {
        path: '/downloads/:id',
        name: 'Show Download',
        component: page('DownloadView'),
        hidden: true
    }
]
